/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  ExtendedFlex,
  Formatters,
  TooltipIcon,
  Tooltip,
  Body,
} from '../../coreui';

import DashboardTableCell from './DashboardTableCell';
import PendingDashboardActionCell from './PendingDashboardActionCell';
import PendingDashboardCancelCell from './PendingDashboardCancelCell';
import HeaderComponent from './TableHeader';
import StyledTable from './StyledTable';

const columns = (investments) => {
  const sumAmount = investments.reduce(
    (accum, item) => (accum + item.amount), 0.00,
  );

  return [
    {
      Header: <HeaderComponent>Investment</HeaderComponent>,
      accessor: 'investment',
      minWidth: 300,
      Cell: DashboardTableCell(),
      id: 'investmentUrl',
    },
    {
      Header: <HeaderComponent>Type</HeaderComponent>,
      accessor: 'type',
      Cell: DashboardTableCell(),
    },
    {
      Header: <HeaderComponent>Date</HeaderComponent>,
      accessor: 'date',
      show: false,
    },
    {
      Header: <HeaderComponent>Amount</HeaderComponent>,
      accessor: 'amount',
      Cell: DashboardTableCell(Formatters.DOLLARS_DECIMALS),
      ...(investments.length === 0 ? {} : {
        Footer: () => {
          return (
            <HeaderComponent>
              {numeral(sumAmount).format(Formatters.DOLLARS_DECIMALS)}
            </HeaderComponent>
          );
        },
      }),
    },
    {
      Header: <HeaderComponent>Date</HeaderComponent>,
      accessor: 'date',
      Cell: DashboardTableCell(Formatters.MMDDYYYY),
    },
    {
      width: 350,
      Header: <HeaderComponent justify="center">Action</HeaderComponent>,
      accessor: 'action',
      Cell: (props) => <PendingDashboardActionCell {...props} />,
    },
    {
      width: 150,
      Header: <HeaderComponent justify="center">Cancel</HeaderComponent>,
      Cell: (cellProps) => (
        <PendingDashboardCancelCell
          {...cellProps}
          // When the user removes the item from their list, React needs to
          // know that this component completely changed. Otherwise, the modal
          // stays open.
          key={`pledgedInvestmentsCancelCell:${cellProps.original.id}`}
        />
      ),
      accessor: 'cancel',
    },
  ];
};

const PledgedInvestmentsTable = ({ investments, tooltip }) => {
  if (!investments) {
    return null;
  }

  return (
    <ExtendedFlex
      flexDirection="column"
      width={1}
      alignItems="center"
      mt={140}
      mx={[50, 50, 50, 0]}
    >
      <StyledTable
        title="Pledged Investments"
        tooltip={
          <>
            <TooltipIcon
              tooltipId="pledgedInvestmentsTooltip"
            />
            <Tooltip id="pledgedInvestmentsTooltip">
              <Body type="B5">
                {tooltip}
              </Body>
            </Tooltip>
          </>
        }
        data={investments}
        columns={columns(investments)}
        noDataText="You have no pledged items."
      />
    </ExtendedFlex>
  );
};

PledgedInvestmentsTable.propTypes = {
  investments: PropTypes.array,
  tooltip: PropTypes.node,
};

export default PledgedInvestmentsTable;
